import { BuyToneDto } from '../../../dto/buytone/buytonedto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface BuyToneRequest extends APIRequest
{
    getBuyToneRequest(): BuyToneDto;
}

export class BuyToneRequestImpl extends APIRequestDtoImpl implements BuyToneRequest
{
    constructor(private buyToneData: BuyToneDto)
    {
        super();
    }

    getBuyToneRequest(): BuyToneDto
    {
        return this.buyToneData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/buytune/buytonerequest.tsx